module.exports = __webpack_public_path__ + "static/bayaddirect-deb75c7108b904bb5e946dd7031fb8de.jpg";